import React from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import AgentReviewAnalysis from './AgentReviewAnalysis';
import { AgentMarketPlaceItemWithFilter } from '../../userAgent/agentMarketPlace/AgentMarketPlace';

interface AgentReviewAnalysisDialogProps {
  open: boolean;
  onClose: () => void;
  agent: AgentMarketPlaceItemWithFilter;
  onReviewChange: () => void;
}

const AgentReviewAnalysisDialog: React.FC<AgentReviewAnalysisDialogProps> = ({
  open,
  onClose,
  agent,
  onReviewChange,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xl"
      scroll="paper"
      PaperProps={{
        sx: {
          minHeight: '90vh',
          maxHeight: '95vh',
        },
      }}
    >
      <Box sx={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ height: '100%', overflowY: 'auto', p: 1 }}>
        {agent && (
          <AgentReviewAnalysis
            agentId={agent._id}
            agentName={agent.name}
            agentOwner={agent.owners?.[0]?.name || ''}
            agentDetails={agent}
            onReviewChange={onReviewChange}
            onClose={onClose}
          />
        )}
      </Box>
    </Dialog>
  );
};

export default AgentReviewAnalysisDialog;
